<div class="flex basis-full gap-8 flex-wrap">
  @if (config().status; as status) {
    <div class="flex items-center gap-8 min-w-[132px]">
      <span class="status-label status-{{ config().status }} uppercase">{{ status }}</span>
    </div>
  }
  <blaze-dates-range-picker
    [value]="config()"
    [errors]="ruleErrors()"
    (valueChanged)="onDatesChanged($event)"
  />
</div>
<div class="flex gap-8 items-center">
  @if (canSave()) {
    <button
      class="button flex rounded py-8 px-16 items-center whitespace-nowrap bg-accent text-11 font-semibold text-base-white h-32"
      blazeClickable
      blazeBarButton
      [blazeTooltip]="saveTooltip()"
      matTooltipPosition="above"
      [disabled]="hasErrors() || !hasAnyTimeSlots() || hasMissingConfig()"
      (click)="saveChanges.emit()"
    >
      Save
    </button>
  }
  <button
    class="button flex rounded p-8 border border-base-transparent hover:border-a-12"
    blazeClickable
    blazeTooltip="Duplicate this schedule"
    matTooltipPosition="above"
    (click)="copySchedule.emit()"
  >
    <mat-icon svgIcon="icon_copy_to_clipboard_32" class="icon-24" />
  </button>
  <button
    class="button flex rounded p-8"
    blazeClickable
    blazeTooltip="Remove this schedule"
    matTooltipPosition="above"
    (click)="deleteSchedule.emit()"
  >
    <mat-icon svgIcon="icon_trash_24" class="icon-24" />
  </button>
  <button class="button flex rounded p-8" blazeClickable (click)="toggleRules.emit()">
    <mat-icon
      [svgIcon]="isExpanded() ? 'icon_chevron_down_16' : 'icon_chevron_right_16'"
      class="icon-24"
    />
  </button>
</div>
